<!-- 内容存档 -->
<template>
  <div class="home">
    <div class="head-title">内容存档</div>
    <el-collapse v-model="activeNames" style="margin-bottom: 2.0rem;">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业通过微炬云开通会话内容存档功能后，只需要在管理后台就能够实现对相关的部门或者员工进行会话内容存档。
          </p>
          <p>2、在使用企业微信会话存档时，员工与客户都具有知情权。</p>
          <p>
            3、经外部联系人同意后，企业可获取外部联系人与开启范围内员工的会话内容。
          </p>
          <p>
            4、后台实时获取，员工与内外部单聊、群聊的聊天内容合规存档，内容包括文本、图片、文件（包括视频文件等）、语音条及撤回消息等消息类型。
          </p>
          <p>
            5、可根据员工和客户进行搜索，同时支持查看企业所有会话内容。<router-link
              class="help-link"
              to="param"
              >配置教程</router-link
            >
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <div class="">
        <div class="tianjia">
          <el-form label-width="12.0rem">
            <div :class="staff == true ? 'a' : ''" @click="staffo()">
              根据员工检索
            </div>
            <div :class="client == true ? 'a' : ''" @click="cliento()">
              根据客户检索
            </div>
            <div :class="pandect == true ? 'a' : ''" @click="pandecto()">
              会话总览
            </div>
          </el-form>
          <div style="margin-top: 2.9rem;height: auto;">
            <!-- 根据员工检索 -->
            <div v-if="staff == true" class="staffo_home">
              <staff></staff>
            </div>
            <!-- 根据客户检索 -->
            <div v-if="client == true" class="staffo_home">
              <client></client>
            </div>
            <!-- 会话总览 -->
            <div v-if="pandect == true" style="width: 100%; height: 100%">
              <pandect></pandect>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import staff from "../../components/monitoring/staff";
import pandect from "../../components/monitoring/pandect";
import client from "../../components/monitoring/client";
export default {
  data() {
    return {
      tableData: [],
      hasChildren: true,
      tooken: "",
      staff: true, //根据员工检索 显示隐藏
      client: false, //根据客户检索 显示隐藏
      pandect: false, //会话总览 显示隐藏,
      activeNames: [],
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.coneten();
    this.updateChatrecord();
  },
  components: {
    staff,
    pandect,
    client,
  },
  methods: {
    updateChatrecord() {
      this.axios
        .post(
          "/home/Wxwork/updateChatrecord",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {})
        .catch(function (err) {});
    },
    coneten() {
      //       // 2
      this.axios
        .post(
          "/home/Wxwork/updateDepartment",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,

          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          //  3
          this.axios
            .post(
              "/home/Wxwork/updateDepartmentUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              //               //4
              //               this.axios
              //                 .post(
              //                   "/home/Wxwork/updateExternalcontactList",
              //                   qs.stringify({
              //                     usertoken: this.tooken.usertoken,
              //                     phone: this.tooken.phone,
              //                     account_id: this.tooken.account_id,
              //                   }),
              //                   {
              //                     headers: {
              //                       "Content-Type": "application/x-www-form-urlencoded",
              //                     },
              //                   }
              //                 )
              //                 .then((res) => {
              //                   // 5
              //                   this.axios
              //                     .post(
              //                       "/home/Wxwork/getExternalcontactList", //home/Wxwork/updateGroupchatList
              //                       qs.stringify({
              //                         usertoken: this.tooken.usertoken,
              //                         account_id: this.tooken.account_id,
              //                         phone: this.tooken.phone,
              //                       }),
              //                       {
              //                         headers: {
              //                           "Content-Type":
              //                             "application/x-www-form-urlencoded",
              //                         },
              //                       }
              //                     )
              //                     .then((res) => {
              //                       // 6
              //                       this.axios
              //                         .post(
              //                           "/home/Wxwork/updateGroupchatList", //home/Wxwork/updateGroupchatList
              //                           qs.stringify({
              //                             usertoken: this.tooken.usertoken,
              //                             account_id: this.tooken.account_id,
              //                             phone: this.tooken.phone,
              //                           }),
              //                           {
              //                             headers: {
              //                               "Content-Type":
              //                                 "application/x-www-form-urlencoded",
              //                             },
              //                           }
              //                         )
              //                         .then((res) => {})
              //                         .catch(function (err) {});
              //                     })
              //                     .catch(function (err) {});
              //                 })
              //                 .catch(function (err) {});
            })
            .catch(function (err) {});
        })
        .catch(function (err) {});
    },
    //根据员工检索 显示隐藏
    staffo() {
      this.staff = true;
      this.client = false;
      this.pandect = false;
      this.coneten();
    },

    //根据客户检索 显示隐藏
    cliento() {
      this.staff = false;
      this.client = true;
      this.pandect = false;
      this.coneten();
    },
    //会话总览 显示隐藏
    pandecto() {
      this.staff = false;
      this.client = false;
      this.pandect = true;
      this.coneten();
    },
  },
};
</script>
<style>
.el-tree {
  background: none !important;
}
</style>
<style scoped>
.home {
  height: 100%;
  overflow-y: auto;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
.wei_body {
  margin-top: 1.0rem;
  width: 100%;
  /* height: 94.2rem; */
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 2.6rem;
}
.el-form {
  display: flex;
  border-bottom: .1rem solid #dbdbdb;
}
.el-form > div {
  display: inline-flex;
  margin-right: 6.0rem;
  font-weight: 500;
  padding-bottom: 2.6rem;
  font-size: 1.8rem;
  cursor: pointer;
  color: #666666;
}
.a {
  color: #49B372 !important;
  border-bottom: .2rem solid;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}

.show {
  display: inline-block;
}
.conceal {
  display: none;
}
.staffo_home {
  width: 100%;
  height: 100%;
}

.one{
  display: inline-block;
  overflow: hidden;
  width: 60.0rem;
  height: 36.6rem;
  background: #FDFEFD;
  border-radius: .8rem;
  border: .1rem solid #E6E6E6;
  margin-right: 2.0rem;

}
.two{
  display: inline-block;
  overflow: hidden;
  width: 85.2rem;
  height: 36.6rem;
  background: #FDFEFD;
  border-radius: .8rem;
  border: .1rem solid #E6E6E6;
}
.three{
  overflow: hidden;
  display: block;
  width: 148.0rem;
  height: 55.0rem;
  background: #FDFEFD;
  border-radius: .8rem;
  border: .1rem solid #E6E6E6;
  margin-top: 2.0rem;
}


.staffo_home_nav > span {
  font-size: 2.2rem;
}
.staffo_home_body {
  width: 100%;
  height: 66.2rem;
  background: rgba(251, 251, 251, 1);
  overflow: hidden;
  overflow-y: auto;
}
.select {
  width: 100%;
  height: 4.0rem;
  margin-top: 4.0rem;
  display: flex;
  justify-content: space-around;
}
.select > span {
  cursor: pointer;
}
.select > span:hover {
  color: #3088db;
}
.gain {
  color: #3088db;
}
.no_gain {
  color: #4c4c4c;
}
.staff {
  width: 100%;
  height: 4.0rem;
  margin-top: 2.0rem;
  display: flex;
  justify-content: space-around;
}
.staff > span {
  cursor: pointer;
}
.staff > span:hover {
  color: #3088db;
}
.overview {
  width: 100%;
  height: 100% !important;
  padding: 1.5rem 0;
  background: rgba(250, 253, 255, 1);
  border: .1rem solid rgba(210, 210, 210, 1);
}
.overview_nav {
  width: 100%;
  height: 5.0rem;
}
.overview_nav > span {
  margin-right: 2.0rem;
}
.overview_body {
  width: 100%;
  height: 67.4rem;
  overflow: hidden;
  overflow-y: auto;
}
.leix > span {
  position: relative;
  bottom: .2rem;
}
.el-tree-node__content {
  width: 100%;
}
.interior {
  margin-top: 3.0rem;
  display: inline-block;
  float: left;
  width: 100%;
}
.staffo_home_body_section {
  display: flex;
  justify-content: space-around;
  margin-top: 4.0rem;
}
.chatting_records {
  width: 90%;
  margin-top: 2.0rem;
  margin-left: 5%;
}
.chatting_records_fasong {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-top: 1.0rem;
  margin-bottom: 1.0rem;
  justify-content: flex-end;
}
.touxiang {
  width: 5.0rem;
  height: 5.0rem;
}
.information {
  display: inline-block;
  max-width: 70%;
  margin-right: 1.0rem;
  position: relative;
  bottom: 1.0rem;
}
.information_name {
  margin-bottom: .5rem;
  text-align: right;
  color: #999999;
}
.conversation_body {
  box-shadow: .0rem .1rem .3rem .0rem rgba(167, 167, 167, 0.2);
  padding: 1.0rem;
  border-radius: .3rem;
  min-height: 2rem;
  background-color: rgba(255, 255, 255);
}
.name_docmsg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 30.0rem;
  height: 10.0rem;
  color: black;
}
.name_docmsg_name {
  width: 18.0rem;
  height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  top: 2.0rem;
}
.name_docmsg_haha {
  font-size: 1.6rem;
  color: rgb(181, 181, 181);
  margin-top: 2.0rem;
}
/* 文档在线文档 */
.abc {
  display: inline-block;
}
.name_docmsg > img {
  /*margin-left: 4.0rem;*/
  /*margin-bottom: 2.5rem;*/
  width: 5rem;
  height: 5rem;
}
/* 直播css */
.link_zhibo {
  width: 30.0rem;
  height: 10.0rem;
}
.link_imges {
  width: 100%;
  height: 4.0rem;
}
.link_imges > img {
  width: 3.0rem;
  height: 3.0rem;
  border-radius: 50%;
}
.link_imges > span {
  font-size: 1.6rem;
  color: rgb(181, 181, 181);
  position: relative;
  left: 1.0rem;
  top: -.8rem;
}
.link_biaoti {
  margin-top: 1.0rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 小程序 */
.weapp_body {
  width: 30.0rem;
}
.weapp_nav {
  width: 30.0rem;
  height: 5.0rem;
  z-index: 10;
}
.weapp_imgs {
  width: 30.0rem;
}
.weapp_bottom {
  width: 30.0rem;
}
.weapp_img {
  display: inline-block;
  width: 3.0rem;
  height: 3.0rem;
  position: relative;
  left: 1.0rem;
  top: 1.0rem;
  z-index: 1000;
}
.weapp_text {
  display: inline-block;
  position: relative;
  left: 2.0rem;
  top: .0rem;
  color: #999999;
  font-size: 1.6rem;
}
.weapp_imgs_text {
  width: 30.0rem;
  padding-bottom: 1.0rem;
}
.weapp_imgs_img {
  width: 30.0rem;
  padding-bottom: 1.5rem;
}
.weapp_bottom {
  padding: 1.2rem;
  border-top: .1rem solid rgb(230, 230, 230);
  padding-bottom: 0;
}
.weapp_bottom > img {
  width: 2.0rem;
  height: 2.0rem;
}
.weapp_bottom > span {
  position: relative;
  font-size: 1.6rem;
  color: #999999;
  left: 1.0rem;
  bottom: .3rem;
}
/**/
.el-main{
  overflow: none;

}

</style>

